import type { KnownSocialPlatformTag } from '@root/entities/socials/model/known-social-platform'

export type UnsafeUrlProvider =
  | 'x'
  | 'telegram'
  | 'discord'
  | 'website'
  | KnownSocialPlatformTag

const displayStringMap: Record<UnsafeUrlProvider, string> = {
  x: 'X',
  telegram: 'Telegram',
  discord: 'Discord',
  website: 'Website',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  instagram: 'Instagram',
  facebook: 'Facebook',
  twitch: 'Twitch',
  reddit: 'Reddit',
  github: 'GitHub',
  bluesky: 'Bluesky',
  medium: 'Medium',
  substack: 'Substack',
  pinterest: 'Pinterest',
  threads: 'Threads',
  whatsapp: 'WhatsApp',
  wiki: 'Wikipedia',
  linkedin: 'LinkedIn',
}
export const displayString = (provider: UnsafeUrlProvider): string =>
  displayStringMap[provider]
